export const SWITCH_THEME_MODE = 'SWITCH_THEME_MODE';

export type ThemeModeAction = { type: typeof SWITCH_THEME_MODE };

export const switchThemeModeAction = (): ThemeModeAction => ({ type: SWITCH_THEME_MODE });
